import { render, staticRenderFns } from "./MenuInfoBlock.vue?vue&type=template&id=d6ff2e56&scoped=true&"
import script from "./MenuInfoBlock.vue?vue&type=script&lang=js&"
export * from "./MenuInfoBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6ff2e56",
  null
  
)

export default component.exports